import {HostListener, Component, OnInit,Input, Output, EventEmitter, ElementRef} from '@angular/core';

@Component({
    selector: 'app-multiselect',
    templateUrl: './multiselect.component.html',
    styleUrls: ['./multiselect.component.scss'],
    host: {
    '(document:click)': 'onOutSideClick($event)',
    },
})
export class MultiselectComponent {

  	private _sourceDataType = null; // to keep note of the source data type. could be array of string/number/object
  	private _sourceDataFields: Array<String> = []; 

	public _settings: any;
	public _data: any = [];
	public _copydata: any = [];
	public selectedItems: any = [];
	public isloadSelectedItem = true;
	_placeholder = "Select";

	 @Input() checkError : boolean = false;
	filter: any = {text:''}; 

	constructor(private elementRef: ElementRef) {
  	}

	onOutSideClick(event) {
		if (!this.eventTriggeredInsideHost(event) && this._settings.defaultOpen === true)
			this.toggleDropdown();
	}

	eventTriggeredInsideHost( event ) {
		var current = event.target;
		var host = this.elementRef.nativeElement;
		do {
			if ( current === host ) {
				return( true );
			}
			current = current.parentNode;
		} while ( current );
		return( false );

	}


	defaultSettings: any = {
	    idField: "id",
	    textField: "text",
	    allowSearchFilter: true,
	    limitSelection: 100,
	    clearSearchFilter: false,
	    itemsShowLimit: 999999999999,
	    searchPlaceholderText: "Search",
	    noDataAvailablePlaceholderText: "No data available",
	    showSelectedItemsAtTop: false,
	    defaultOpen: false,
	};

	@Input()
	public set preSelectedItems(value : any){
		if (value !=undefined && value.length > 0 && this.isloadSelectedItem) {
	      	value.forEach(key => {
				this.selectedItems.push({
					  id: key,
		              text: key
				});
			})
	    }
	}

    @Input()
	public set placeholder(value: string) {
	    if (value) {
	      	this._placeholder = value;
	    } else {
	      	this._placeholder = "Select";
	    }
	}

  	@Input()
	public set settings(value: any) {
	    if (value) {
	      	this._settings = Object.assign(this.defaultSettings, value);
	    } else {
	      	this._settings = Object.assign(this.defaultSettings);
	    }
	}

	@Input()
	public set data(value: Array<any>) {
	  	this._data = [];
	    if (Array.isArray(value)) {
	        const firstItem = value[0];
		    if (firstItem !=undefined) {
			    this._sourceDataType = typeof firstItem;
			    this._sourceDataFields = this.getFields(firstItem);
			    this._data = value.map((item: any) =>
			        typeof item === "string" || typeof item === "number"
			          ? item : {id: item[this._settings.idField], text: item[this._settings.textField]}
			      );
			} 
	    } else if (typeof value === 'object') {
			Object.keys(value).forEach(key => {
				this._data.push({
					  id: key,
		              text: value[key]
				});
			});
		} else {
			this._data = value;
		}
		if (this._data.length > 0)
			this._data.sort(this.compare);
		this._copydata = this._data;
	}

	getFields(inputData) {
	    const fields = [];
	    if (typeof inputData !== "object") {
	      return fields;
	    }
	    for (const prop in inputData) {
	      fields.push(prop);
	    }
	    return fields;
	}

	onFilterTextChange($event) {

		this._data = this._copydata.filter((item: any) => {
			if (typeof item.text === 'string' && typeof this.filter.text === 'string') {
	            return !(this.filter.text && item.text
	             && item.text.toLowerCase().indexOf(this.filter.text.toLowerCase()) === -1);
	        } else {
	            return !(this.filter.text && item.text
	             && item.text.toString().toLowerCase().indexOf(this.filter.text.toString().toLowerCase()) === -1);
	        }
		});
		this._data.sort(this.compare);
	}

  	@Output("onSelectedItems")
  	onSelectedItems: EventEmitter<any> = new EventEmitter<any>();

  //html functions
	toggleDropdown() {
	    this._settings.defaultOpen = !this._settings.defaultOpen;
	    if (this._settings.clearSearchFilter) {
	      this.filter.text = "";
	    }
	}

	trackByFn(index, item) {
	    return item.id;
	}

	compare(a, b) {
	  // Use toUpperCase() to ignore character casing
	  const bandA = a.text.toUpperCase();
	  const bandB = b.text.toUpperCase();

	  let comparison = 0;
	  if (bandA > bandB) {
	    comparison = 1;
	  } else if (bandA < bandB) {
	    comparison = -1;
	  }
	  return comparison;
	}

	onItemClick($event: any, item: any) {
	  	$event.stopPropagation();
	    const found = this.isSelected(item);
	    const allowAdd = this._settings.limitSelection === -1
	     || (this._settings.limitSelection > 0
	      && this.selectedItems.length < this._settings.limitSelection);
	    if (!found) {
	      if (allowAdd) {
	        this.addSelected(item);
	      }
	    } else {
	      this.removeSelected(item);
	    }
	}

	isSelected(clickedItem: any) {
	    let found = false;
	    this.selectedItems.forEach(item => {
	      if (clickedItem.id === item.id) {
	        found = true;
	      }
	    });
	    return found;
	}

	addSelected(item: any) {
	    this.selectedItems.push(item);
	    this.onSelectedItems.emit(this.emittedValue());
	}

	removeSelected(itemSel: any) {
	    this.selectedItems.forEach(item => {
	      	if (itemSel.id === item.id) {
	        	this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
	      	}
	    });
	    this.onSelectedItems.emit(this.emittedValue());
	}

	emittedValue(): any {
	    const selected = [];
	    this.selectedItems.forEach(item => {
	    	selected.push(item.id);
	    });
	    return selected;
	}

	get hasError() {
	    if (!this.checkError) {
	      return false;
	    }
	    return this.selectedItems.length  > 0 ? false : true;
	}
	
	itemShowRemaining(): number {
	    return this.selectedItems.length - this._settings.itemsShowLimit;
	}

	getToolTip(): string {
		if (this.isloadSelectedItem && this._copydata.length > 0) {
			const items = [];
			this.selectedItems = this.selectedItems.map(item => {
				let filterData = this._copydata.filter((itemdata: any) => {
						return itemdata.id === item.id
				});
				items.push(filterData[0]);
			});
			this.selectedItems = items;
			this.isloadSelectedItem = false;
		}
		
	    return this.selectedItems.length > 0 
	    	? this.selectedItems.map(item => item && item.text === undefined ? item.id : item.text).join(', ') : this._placeholder;
	}

	isLimitSelectionReached(): boolean {
	    return this._settings.limitSelection === this.selectedItems.length;
	}	
	  // Only AlphaNumeric
	  keyPressAlphaNumeric(event) {

		var inp = String.fromCharCode(event.keyCode);
	
		if (/[a-zA-Z0-9]/.test(inp)) {
		  return true;
		} else {
		  event.preventDefault();
		  return false;
		}
	  }
}
